import { Link } from "react-router-dom";

const SPOTTERS = [
  {
    name: "The Skeptic",
    role: "Head of Authenticity",
    codename: "K-01",
    quote: "Assume it's fake. Prove me wrong.",
    portrait: "https://images.unsplash.com/photo-1603189343302-e603f7add05a?w=1200",
    checklist: ["Cross-reference brand tags", "Verify vendor invoice chain", "Match material batch to source", "Reject if any doubt remains"],
  },
  {
    name: "The Perfectionist",
    role: "Head of Quality",
    codename: "K-02",
    quote: "I count stitches. All of them.",
    portrait: "https://images.unsplash.com/photo-1758522277818-56d9f6a1636a?w=1200",
    checklist: ["Stitch density measurement", "Seam symmetry scan", "Zero glue-spill tolerance", "Finish photographs at 4x zoom"],
  },
  {
    name: "The Softie",
    role: "Head of Fit & Comfort",
    codename: "K-03",
    quote: "If it hurts, we don't ship it.",
    portrait: "https://images.unsplash.com/photo-1771523350533-a831d1f703a7?w=1200",
    checklist: ["Wear-test each new batch", "BIS size verification", "Fabric hand-feel scoring", "Return-rate flag if >3%"],
  },
];

export default function Spotters() {
  return (
    <div>
      <section className="border-b border-foreground max-w-[1600px] mx-auto px-6 md:px-12 py-24">
        <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">The People · Certif. № TS-2026</p>
        <h1 className="font-serif text-7xl md:text-9xl mt-4 leading-[0.85] tracking-tighter max-w-5xl">
          Three humans. <em className="text-[hsl(var(--accent))] not-italic">One&nbsp;</em>signature.
        </h1>
        <p className="mt-8 max-w-xl text-muted-foreground">
          Software can't count stitches. So we hired three people who do it for you — every parcel, every batch, every day at the Delhi hub.
        </p>
      </section>

      {SPOTTERS.map((s, idx) => (
        <section key={s.codename} className={`border-b border-foreground ${idx % 2 ? "bg-foreground text-background" : ""}`}>
          <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 grid md:grid-cols-12 gap-12 items-center">
            <div className={`md:col-span-5 ${idx % 2 ? "md:order-2" : ""}`}>
              <div className="aspect-[4/5] overflow-hidden">
                <img src={s.portrait} alt={s.name} className="w-full h-full object-cover grayscale contrast-125" />
              </div>
            </div>
            <div className={`md:col-span-7 ${idx % 2 ? "md:order-1" : ""}`}>
              <p className={`font-mono text-[10px] uppercase tracking-widest ${idx % 2 ? "text-background/60" : "text-muted-foreground"}`}>
                {s.codename} · {s.role}
              </p>
              <h2 className="font-serif text-6xl md:text-8xl mt-3 leading-none tracking-tighter">{s.name}</h2>
              <p className="font-serif italic text-3xl md:text-4xl mt-8 leading-tight">"{s.quote}"</p>
              <div className="mt-10 grid grid-cols-2 gap-x-6 gap-y-3">
                {s.checklist.map((c, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <span className={`w-6 h-6 border-2 flex items-center justify-center font-mono text-[10px] shrink-0 ${idx % 2 ? "border-background" : "border-foreground"}`}>✓</span>
                    <p className="text-sm mt-1">{c}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      ))}

      <section className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 text-center">
        <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Join the roster</p>
        <h2 className="font-serif text-5xl md:text-7xl mt-4 tracking-tighter">Want us to inspect your things?</h2>
        <Link to="/sell" data-testid="cta-sell" className="inline-block mt-10 bg-foreground text-background px-10 py-5 font-mono text-xs uppercase tracking-[0.24em] hover:bg-[hsl(var(--accent))]">
          Become a Vendor
        </Link>
      </section>
    </div>
  );
}
